import { lazy } from 'react'

export const SecondaryGoal = lazy(() => import('./SecondaryGoal'))
